// extracted by mini-css-extract-plugin
export default {"companyContainer":"xP-z","companyImage":"yP-z","container":"zP-z","heading":"AP-z","darkText":"BP-z","smallHeading":"CP-z","darkBackground":"DP-z","whiteBackground":"EP-z"};